type TValidationErrorItem = {
  message?: string;
  property?: string[];
};

function isValidationErrorItem(value: unknown): value is TValidationErrorItem {
  return (
    typeof value === 'object' &&
    value !== null &&
    'message' in value &&
    typeof (value as TValidationErrorItem).message === 'string'
  );
}

/**
 * Normalizes API error bodies (string message or Joi validation array) for UI display.
 */
export function getApiErrorMessage(
  error: unknown,
  fallback = 'Something went wrong.  Please try again or contact support for help.',
): string {
  if (typeof error !== 'object' || error === null || !('data' in error)) {
    return fallback;
  }

  const data = (error as { data?: { message?: unknown } }).data;
  const message = data?.message;

  if (typeof message === 'string' && message.length > 0) {
    return message;
  }

  if (Array.isArray(message)) {
    const first = message.find(isValidationErrorItem);
    if (first?.message) {
      return first.message;
    }
  }

  return fallback;
}
